
  <form [formGroup]="doQuestionForm"  *ngIf="question">
  <span *ngIf="isRadioGroup">
   <div>(<i>Select the Correct Answer from options below</i>)</div>
    <table class="table">
      <tbody>
        <tr *ngFor="let choice of question.choiceOptions; index as myCount">
        <td>
           <div class="answer-option-radio-div">
             <input
             type="radio"
             [id]="myCount"
             formControlName="answerChoice"
             [value]="extractChoiceValue(choice)"
             style="height:35px; width:35px; vertical-align: middle;"/>
             <span [appMath]="' '+choice.display"></span>
            </div>
        </td>
        </tr>
      </tbody>
     </table>
    </span>
    <div class="row"  *ngIf="isInput">
            <div class="col-sm-4" ></div>
            <div class="col-sm-4" >
                <input   formControlName="answerInput" class="form-control mt-4" placeHolder="Type answer Here" />
            </div>
    </div>


        <div class="navcard row mt-4" *ngIf="question.server_question_id!=0">
            <div class="col-sm-12 text-center">
            <button *ngIf ="questionIndex==0" class="btn btn-secondary btn-lg me-3"><i class="fa fa-angle-double-left"></i> Back</button>
            <button *ngIf="questionIndex!=0"
                type="button"
                (click)="onPreviousQuestion()"
                class="backnav btn btn-primary btn-lg me-3"><i
                class="fa fa-angle-double-left"></i> Previous Question
            </button>
            <button *ngIf="!(questionIndex+1 == quizEnvelop.questions.length)"
                type="button"
                (click)="onNextQuestion()"
                class="forwardnav btn btn-primary btn-lg">Next Question <i class="fa fa-angle-double-right"></i>
            </button>

            <button *ngIf="!quizEnvelop.isCompleted && (isLastQuestion)"
                type="button"
                (click)="onSaveForMarking()"
                class="save btn btn-primary  btn-lg" > Save For Marking
            </button>
        </div>
        </div>
  </form>



